/** A list filter from the URL ("BUCKET_31_60,BUCKET_61_90"); unknown values dropped. */
export function parseListParam<T extends string>(raw: unknown, allowed: readonly T[]): T[] {
  if (typeof raw !== 'string' || raw === '') return []
  const values = raw.split(',').map((v) => v.trim())
  return allowed.filter((a) => values.includes(a))
}

/** Adds the value if absent, removes it if present; keeps `order`'s order. */
export function toggleIn<T extends string>(list: readonly T[], value: T, order: readonly T[]): T[] {
  const next = list.includes(value) ? list.filter((v) => v !== value) : [...list, value]
  return order.filter((o) => next.includes(o))
}
